// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"styles_testimonials__1WRzW","testimonial":"styles_testimonial__3bTQd","quote":"styles_quote__FKeX-","byLine":"styles_byLine__1Zl02"};